export const getRelationshipTypes = state => state.toJS();



// WEBPACK FOOTER //
// ./src/redux/selectors/RelationshipTypesSelectors.js